// The ONE money formatter in this bundle.
//
// ⚠️ THERE WERE TWO, AND BOTH WERE WRONG. `peso()` at ServiceDesk.jsx:1122 and
// TimeApproval.jsx:24 were byte-identical and both used
// `minimumFractionDigits: 0` with no maximum, so ₱1,234.50 rendered as
// "₱1,234.5" on a money screen: a figure that reads as five pesos short of
// itself, on the page a manager bills from. Both are replaced by this module
// and a third copy must not be written.
//
// ⚠️ IT TAKES INTEGER CENTAVOS, because that is what the API returns. A
// billing line carries `amount_minor` and NO derived float beside it
// (backend/billing.py `_line`), so the browser is the last converter, and the
// conversion has to live in one place or the fleet grows a second rounding
// rule. Dividing by 100 for display is the ONLY money arithmetic this bundle
// is allowed to do: no summing lines to check a total, no deriving a rate.
// The server's total is the record, and a second computation that disagrees
// with it is a bug generator, not a check.

const MINOR_PER_UNIT = 100;

// Two decimals, always, both ends. `minimumFractionDigits` alone is what
// produced "₱1,234.5"; `maximumFractionDigits` alone would let ₱1,234.00
// render as "₱1,234". A money column whose rows have different numbers of
// decimal places cannot be scanned down.
const FMT = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Integer centavos as a peso string, e.g. 123450 -> "₱1,234.50".
 *
 * ⚠️ `null` and `undefined` are NOT zero. The unbilled report deliberately
 * returns `amount_minor: null` on a row it cannot add up ("a number rendered
 * in a money column that no total includes is worse than a blank"), and
 * printing ₱0.00 there would state a figure the server refused to state.
 * Callers get `null` back and must say in words why there is no amount.
 */
export function peso(minor, { currency = "₱" } = {}) {
  if (minor === null || minor === undefined || minor === "") return null;
  const n = Number(minor);
  if (!Number.isFinite(n)) return null;
  return `${currency}${FMT.format(n / MINOR_PER_UNIT)}`;
}

/**
 * The same figure with a fallback for the empty case, so a table cell never
 * renders a bare dash. `fallback` is a SENTENCE, not a symbol: "a list column
 * that renders a dash on every row makes a working system look broken".
 */
export function pesoOr(minor, fallback) {
  const s = peso(minor);
  return s === null ? fallback : s;
}
